import i18next from 'i18next';
import {config} from './config';

const i18n = i18next.createInstance(config, (error) => {
  if (error) console.log(error);
});

export default i18n;
